export default __webpack_public_path__ + "static/media/al.a021bb14.jpg";